import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";

interface CdsConfigurationValidationModel {
  entityDefinition?: { metadataId?: string } | null;
  statuses?: { value: number }[] | null;
  doneStatus?: { value: number } | null;
}

export const getCdsSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  if (!editingConnection.isAuthorised) {
    return "";
  }

  const configuration =
    parseConnectionConfiguration<CdsConfigurationValidationModel>(
      editingConnection.configuration,
    );

  if (!configuration.entityDefinition?.metadataId) {
    return t("board.connections.dialog.sourceSettings.cds.entityDefinitionRequired");
  }

  // Completing a card moves its record to the done status; if that status is also loaded, the
  // record stays on the board as an open card.
  const doneStatus = configuration.doneStatus;
  const doneIsAlsoLoaded =
    !!doneStatus && (configuration.statuses ?? []).some((status) => status.value === doneStatus.value);

  return doneIsAlsoLoaded
    ? t("board.connections.dialog.sourceSettings.cds.doneStatusAlsoLoaded")
    : "";
};
